import { Tooltip, UnstyledButton } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./composer.module.css";

export interface ToggleChipProps {
  /** The setting's name, read with its state: "Loop", "Instrumental". */
  setting: string;
  icon: ReactNode;
  on: boolean;
  onChange: (on: boolean) => void;
  /** Live's tooltip. */
  tip: string;
}

/**
 * Live's toggle chip (its `MantineFormToggleChip`, captures 01 and 04): the icon and "On" or
 * "Off", light indigo while on.
 */
export function ToggleChip({ setting, icon, on, onChange, tip }: ToggleChipProps) {
  return (
    <Tooltip label={tip} multiline maw={300} withArrow>
      <UnstyledButton
        className={classes.chip}
        data-on={on || undefined}
        aria-label={setting}
        aria-pressed={on}
        onClick={() => onChange(!on)}
      >
        {icon}
        <span aria-hidden>{on ? "On" : "Off"}</span>
      </UnstyledButton>
    </Tooltip>
  );
}
